import { Component } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

import { SidenavTreeComponent } from './components/shared/sidenav-tree/sidenav-tree.component';
import { HeaderComponent } from './components/shared/header/header.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [CommonModule, RouterOutlet, SidenavTreeComponent, HeaderComponent]
})
export class AppComponent {

  // Mobile sidenav state
  sidenavOpen: boolean = false;

  // Hide the shared footer on company page (it has its own footer)
  showSharedFooter: boolean = true;

  isLoading: boolean = false;

  constructor(private router: Router) {}

  ngOnInit() {
    // Subscribe to route changes to hide footer on company page
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Hide shared footer on main company page (has its own footer)
      this.showSharedFooter = event.urlAfterRedirects !== '/';
      // Close sidenav on navigation
      this.sidenavOpen = false;
    });

    // Set initial footer visibility
    this.showSharedFooter = this.router.url !== '/';
  }

  toggleSidenav() {
    this.sidenavOpen = !this.sidenavOpen;
  }

  closeSidenav() {
    this.sidenavOpen = false;
  }
}
